<template>
  <div :class="`background-image-rotator ${this.classList.join(' ')}`" :style="backgroundImage">
    <div v-if="media && media[pathIndex] && media[pathIndex].type === 'video'">
      <video width="1024" autoplay :loop="allowLoop" controls="false">
        <source type="video/mp4" :src="this.media[this.pathIndex].path">
      </video>
    </div>
    <div v-if="media && media[pathIndex] && media[pathIndex].type === 'image'">
      <img :src="standardImage" onerror="location.reload(true);">
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash.isequal';

export default {
  props: {
    media: {
      type: Array,
      required: true
    },
    classList: {
      type: Array,
      required: true
    },
    timing: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      timeout: null,
      pathIndex: -1
    }
  },
  watch: {
    media: {
      immediate: false, 
      handler (val, oldVal) {
        if (isEqual(val, oldVal)) return;
        console.log('media changed')
        this.clearTimer();
        this.resetPathIndex();
      }
    },
    'pathIndex': {
      immediate: false, 
      handler (val) {
        console.log('pathIndex changed', val, this.media.length);
        if (val === -1) return;
        
        if (this.media && this.media[val] && this.media[val].type === 'video') {
          this.waitForVideoToFinish();
        } else {
          if (this.media.length <= 1) return;
          this.waitTimer();  
        }
      }
    }
  },
  beforeDestroy () {
    this.clearTimer()
  },
  methods: {
    waitTimer() {
      // console.log('start timer');
      this.timeout = setTimeout(() => {
        this.nextImage()
      }, this.timing)
    },
    waitForVideoToFinish() {
      // console.log('startTimerWhenVideoFinish')
      this.$nextTick(() => {
        const video = document.getElementsByTagName("video")[0];
        if (this.media.length > 1) {
          video.addEventListener("ended", () => {  this.nextImage(); }, { once: true, capture: true });
        }
      })
    },
    clearTimer() {
      clearTimeout(this.timeout)
      this.timeout = null
    },
    nextImage () {
      // console.log('next image');
      if (this.pathIndex + 1 >= this.media.length) {
        // console.log('this.pathIndex = 0');
        this.pathIndex = 0
      } else {
        this.pathIndex++
      }
    },
    resetPathIndex () {
      this.pathIndex = -1;
      this.$nextTick(() => {
        this.pathIndex = 0;
        // console.log('reset pathIndex', this.pathIndex);
      });
    }
  },
  computed: {
    backgroundImage () {
      return '';// (this.media && this.media[this.pathIndex] && this.media[this.pathIndex].type === 'image') ? `background-image: url(${this.media[this.pathIndex].path});` : ''
    },
    standardImage () {
      return (this.media && this.media[this.pathIndex] && this.media[this.pathIndex].type === 'image') ? this.media[this.pathIndex].path : ''
    },
    allowLoop () {
      return (this.media && this.media.length <= 1);
    }
  }
}
</script>

<style lang="scss">
  .background-image-rotator {
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>
